// translations/common/cookies.js
// The first-visit consent dialog (IDD D-HP-SITE-027, D-SAAS-176). {settings} is replaced by the
// footer's label of the cookie settings.

export const cookies = {
  de: {
    cookies: {
      title: 'Datenschutz-Einstellungen',
      description: 'Wir werten Besuchsstatistiken mit Methoden des maschinellen Lernens aus, um unsere Website zu verbessern. Mit Ihrer Einwilligung verarbeiten wir dazu Nutzungs- und Gerätedaten einschließlich Ihrer IP-Adresse und erkennen Ihren Browser bei späteren Besuchen wieder. Die Einwilligung ist freiwillig und jederzeit unter „{settings}“ widerrufbar. Einzelheiten, auch zur Übermittlung in Drittländer, enthält die Datenschutzerklärung.',
      necessary: {
        title: 'Notwendig',
        description: 'Für den Betrieb der Website erforderlich, etwa die Sprachwahl und das Speichern dieser Auswahl.'
      },
      statistics: {
        title: 'Statistik',
        description: 'Seitenaufrufe und Nutzung der Website, ohne Wiedererkennung und ohne Speicherung der IP-Adresse.'
      },
      marketing: {
        title: 'Analyse und maschinelles Lernen',
        description: 'Wiedererkennung bei späteren Besuchen sowie Auswertung der IP-Adresse (ungefährer Standort, Netzbetreiber, Organisation) und von Gerätemerkmalen; Speicherung bis zwölf Monate nach dem letzten Besuch. Dabei wird Ihre IP-Adresse auch an Internet-Registraturen in den USA, Australien und Mauritius übermittelt, für die kein angemessenes Datenschutzniveau festgestellt ist; es besteht das Risiko eines Zugriffs dortiger Behörden und einer erschwerten Durchsetzung Ihrer Rechte.'
      },
      acceptAll: 'Alle akzeptieren',
      rejectAll: 'Nur notwendige',
      settings: 'Einstellungen',
      save: 'Auswahl speichern',
      alwaysOn: 'Immer aktiv'
    }
  },
  en: {
    cookies: {
      title: 'Privacy settings',
      description: 'We evaluate visitor statistics with machine-learning methods to improve our website. With your consent, we process usage and device data for this purpose, including your IP address, and recognise your browser on later visits. Consent is voluntary and can be withdrawn at any time under “{settings}”. Details, including transfers to third countries, are given in the privacy policy.',
      necessary: {
        title: 'Necessary',
        description: 'Required to operate the website, such as the language choice and storing this selection.'
      },
      statistics: {
        title: 'Statistics',
        description: 'Page views and use of the website, without recognition and without storing the IP address.'
      },
      marketing: {
        title: 'Analysis and machine learning',
        description: 'Recognition on later visits and evaluation of the IP address (approximate location, network operator, organisation) and of device characteristics; kept until twelve months after the last visit. In the process, your IP address is also transmitted to Internet registries in the USA, Australia and Mauritius, for which no adequate level of data protection has been established; there is a risk of access by authorities there and of greater difficulty in enforcing your rights.'
      },
      acceptAll: 'Accept all',
      rejectAll: 'Necessary only',
      settings: 'Settings',
      save: 'Save selection',
      alwaysOn: 'Always on'
    }
  },
  nl: {
    cookies: {
      title: 'Privacy-instellingen',
      description: 'Wij analyseren bezoekersstatistieken met methoden van machine learning om onze website te verbeteren. Met uw toestemming verwerken wij daarvoor gebruiks- en apparaatgegevens, inclusief uw IP-adres, en herkennen wij uw browser bij latere bezoeken. Toestemming is vrijwillig en kan op elk moment worden ingetrokken via „{settings}”. Details, ook over doorgifte naar derde landen, staan in de privacyverklaring.',
      necessary: {
        title: 'Noodzakelijk',
        description: 'Vereist voor de werking van de website, zoals de taalkeuze en het opslaan van deze keuze.'
      },
      statistics: {
        title: 'Statistiek',
        description: 'Paginabezoeken en gebruik van de website, zonder herkenning en zonder opslag van het IP-adres.'
      },
      marketing: {
        title: 'Analyse en machine learning',
        description: 'Herkenning bij latere bezoeken en analyse van het IP-adres (geschatte locatie, netwerkaanbieder, organisatie) en van apparaatkenmerken; bewaard tot twaalf maanden na het laatste bezoek. Daarbij wordt uw IP-adres ook doorgegeven aan internetregisters in de VS, Australië en Mauritius, waarvoor geen passend niveau van gegevensbescherming is vastgesteld; er bestaat een risico op toegang door de autoriteiten daar en op een moeilijkere handhaving van uw rechten.'
      },
      acceptAll: 'Alles accepteren',
      rejectAll: 'Alleen noodzakelijke',
      settings: 'Instellingen',
      save: 'Keuze opslaan',
      alwaysOn: 'Altijd actief'
    }
  }
};
